import React from "react";

const WORDS = [
  "AUSTRALIA'S PREMIER RESEARCH PEPTIDES",
  "CLINICAL GRADE",
  "ELITE RECOVERY",
  "PURITY > 99%",
  "LAB TESTED",
  "EXPRESS SHIPPING AUSTRALIA WIDE",
];

export const Marquee = ({ stroke = true }) => {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="border-y border-[#27272A] bg-ink-900 py-5 overflow-hidden" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display font-extrabold text-3xl md:text-5xl px-6 tracking-tight ${
                stroke ? "text-stroke" : "text-white"
              }`}
            >
              {w}
            </span>
            <span className="text-accent text-2xl md:text-4xl">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
};
